import Login from "containers/login";
import React, { Fragment } from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import ErrorPage from "../error";
import Payments from "containers/golfer/payments";
import PaymentSuccess from "containers/payments/success";
import InsuranceLandingPage from "containers/insurance/landing";
import InsuranceApplicationForm from "containers/insurance/application";

export default function PublicRoute() {
  const [pageParams] = useSearchParams();
  return (
    <Fragment>
      <Routes>
        <Route
          exact
          path="/login"
          element={
            <Login
              is_continue={false}
              is_caddy={
                parseInt(pageParams.get("login_type")) === 0 ? true : false
              }
            />
          }
        />
        <Route exact path="/payment" element={<Payments />} />
        <Route exact path="/payment_success" element={<PaymentSuccess />} />
        <Route path="/insurance" element={<InsuranceLandingPage />} />
        <Route path="/insurance/apply" element={<InsuranceApplicationForm />} />

        <Route path="/*" element={<ErrorPage isPublic={true} />} />
      </Routes>
    </Fragment>
  );
}
